import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";

export default class JobService extends AbstractService {
	static endpoint = ENDPOINTS.jobs;

	static jobsEndpoint = "jobs";

	static getById(id) {
		return this.get({
			endpoint: `${this.endpoint}/${id}`,
		});
	}

	static getAdditionalInformationById(id) {
		return this.get({
			endpoint: `${this.endpoint}/${id}/additionalInformation`,
		});
	}

	static getJobHistoryById(id) {
		return this.get({
			endpoint: `${this.endpoint}/${id}/history`,
		});
	}

	static getJobActivityLog(jobId, officerId) {
		return this.get({
			endpoint: `${this.endpoint}/ActivityLog?officerId=${officerId}&JobId=${jobId}`,
		});
	}

	static getApplicantsHistoryById(id, queryParams) {
		return this.get({
			endpoint: `${this.endpoint}/${id}/applicantHistory`,
			queryParams,
		});
	}

	static getAll({ getCancelToken, ...rest }, cache) {
		return this.get({
			endpoint: this.endpoint,
			queryParams: rest,
			getCancelToken,
			cache,
		});
	}

	static addJobNotificationSettings(data) {
		return this.post({
			endpoint: ENDPOINTS.jobNotifications,
			data,
		});
	}

	static deleteJob(queryParams, data) {
		return this.del({
			isV2API: true,
			endpoint: this.endpoint,
			queryParams,
			data,
		});
	}

	static deleteMultipleJobs(data) {
		return this.del({
			endpoint: this.endpoint,
			data,
		});
	}

	static postJob(queryParams, data) {
		return this.put({
			endpoint: `${this.endpoint}/publish`,
			queryParams,
			data,
		});
	}

	static postMultipleJobs(queryParams, data) {
		return this.put({
			endpoint: `${this.endpoint}/publish/multiple`,
			queryParams,
			data,
		});
	}

	static getCounts({ getCancelToken, ...rest }) {
		return this.get({
			endpoint: `${this.endpoint}/${ENDPOINTS.counts}`,
			queryParams: rest,
			getCancelToken,
		});
	}

	static getAllByOfficerId(officerId, queryParams) {
		return this.get({
			endpoint: `${ENDPOINTS.officers}/${officerId}/${this.endpoint}`,
			queryParams,
		});
	}

	static add(data) {
		return this.post({
			endpoint: this.endpoint,
			data,
		});
	}

	static edit(queryParams, data) {
		return this.put({
			endpoint: `${this.endpoint}`,
			queryParams,
			data,
		});
	}

	static getCheckIns(id, userId, getCancelToken) {
		return this.get({
			endpoint: `${ENDPOINTS.checkIns}/${id}`,
			queryParams: { userId },
			getCancelToken,
		});
	}

	static restore(queryParams) {
		return this.put({
			endpoint: `${this.endpoint}/restore`,
			queryParams,
		});
	}

	static getApplicantsByPositionId(id) {
		return this.get({
			endpoint: `${this.jobsEndpoint}/${id}/applications`,
			cache: { maxAge: 0 },
		});
	}

	static getAssignedOfficersByPositionId(id) {
		return this.get({
			endpoint: `${this.jobsEndpoint}/${id}/assignedOfficers`,
			cache: { maxAge: 0 },
		});
	}

	static getJobEstimateByData({ queryParams, data, getCancelToken }) {
		return this.post({
			endpoint: `${this.endpoint}/invoiceestimate`,
			queryParams,
			data,
			getCancelToken,
		});
	}

	static getJobEstimateById(id) {
		return this.get({
			endpoint: `${this.endpoint}/invoiceestimate`,
			queryParams: { jobEventId: id },
		});
	}

	static getNonRKPayInvoices(queryParams) {
		return this.get({
			endpoint: "NonRKPayInvoices/JobEvents",
			queryParams,
		});
	}

	static getUnInvoicedJobs(queryParams) {
		return this.get({
			endpoint: "NonRKPayInvoices/JobEvents/uninvoiced",
			queryParams,
		});
	}

	static getSchedulingOnlyOptions(clientId) {
		return this.get({
			endpoint: `${this.endpoint}/schedulingonlyoptions?clientId=${clientId}`,
		});
	}

	static upsertSchedulingOnlyOptions(data) {
		return this.put({
			endpoint: `${this.endpoint}/schedulingonlyoptions`,
			data,
		});
	}

	static getJobEventPositions(jobEventId) {
		return this.get({
			endpoint: `${this.endpoint}/${jobEventId}/positions`,
		});
	}

	static uploadJobEventAttachment(file) {
		const formData = new FormData();
		formData.append("file", file);

		return this.post({
			endpoint: `${this.endpoint}/attachments`,
			data: formData,
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	}

	static getJobEventNonRKPayInvoices(jobEventId) {
		return this.get({
			endpoint: `${this.endpoint}/${jobEventId}/nonRKPayInvoices`
		});
	}
}
